import { Component, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { BreakpointService } from '@core/services/breakpoint.service';

@Component({
    selector: 'app-page-layout',
    templateUrl: './page-layout.component.html',
    styleUrls: ['./page-layout.component.scss'],
    standalone: false
})
export class PageLayoutComponent {
  @Input() public title: string | Observable<string>;
  @Input() public showDivider = true;

  constructor(public readonly breakpointService: BreakpointService) {}
}
